import {
  //BrowserRouter,
  Route,
  Routes,
  //createBrowserRouter,
  //createRoutesFromElements,
  //RouterProvider,
  Outlet,
  //useNavigate,
} from "react-router-dom";
//import LoginPage from "./components/pages/login/LoginPage";
//import LoginGPTPage from "./components/pages/login-gpt/LoginGPTPage";
//import HomePage from './components/pages/home/HomePage';
import HomePage from "./components/pages/home/v3/HomePage";
//import HomeAntPage from "./components/pages/home/antd/HomeAntPage";
//import NoteDetail from "./components/pages/home/NoteDetail";
//import NoteNew from "./components/pages/home/NoteNew";
import NotebookDetailsPage from "./components/pages/home/v3/NotebookDetailsPage";
import SettingsPage from "./components/pages/settings/SettingsPage";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBook,
  faBookmark,
  faEdit,
  faSave,
  faBars,
  faStickyNote,
  faUser,
  faPlus,
  faEyeSlash,
  faSearch,
  faArrowLeft,
  faSignInAlt,
  faSignOutAlt,
  faRocket,
  faCog,
  faPalette,
  faCheck,
  faSquarePlus,
  faCloudArrowUp,
  faCheckCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";

import { NotebookService } from "./services/NotebookService";
//import { Note, NoteBook, NotebookDetailsLoader } from "./model/models";
//import DigitPad from "./components/pages/home/v3/DigitPad";
import PinLoginPage from "./components/pages/home/v3/pin-login/PinLoginPage";
//import PinLoginMinimal from "./components/pages/home/v3/pin-login/PinLoginMinimal";
//import { Context } from "./components/pages/home/v3/context";
import { AuthService } from "./services/AuthService";
import { HTTPService } from "./services/HttpService";
import Layout from "./components/pages/home/v3/Layout";
import RequiredAuth from "./components/pages/home/v3/RequiredAuth";
import { AuthProvider } from "./context/AuthContext";
//import HomeContext, { HomeProvider } from "./context/HomeContext";
import Logout from "./components/pages/home/v3/Logout";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { ClickService } from "./services/ClicksService";
import GlobalSearchNotes from "./components/pages/home/v3/notes/GlobalSearchNotes";

library.add(
  faBook,
  faEyeSlash,
  faRocket,
  faBookmark,
  faEdit,
  faSave,
  faBars,
  faStickyNote,
  faUser,
  faPlus,
  faSearch,
  faArrowLeft,
  faSignInAlt,
  faSignOutAlt,
  faCog,
  faPalette,
  faCheck,
  faSquarePlus,
  faCloudArrowUp,
  faCheckCircle,
  faPencil
);

export const notebookService = new NotebookService();
export const authService = new AuthService();
export const httpService = new HTTPService(authService);
export const clicksService = new ClickService();

export default function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/login" element={<PinLoginPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<RequiredAuth />}>
              <Route path="/" element={<HomePage />}>
                <Route
                  path="notebook/:notebookId"
                  element={<NotebookDetailsPage />}
                  loader={async ({  }) => {
                    // Debug loader calls - can be removed if not needed
                    // logger.debug("loader router " + params.notebookId);
                    /*const notebook = await notebookService.readNotebookById(
                  Number(params.notebookId)
                );
                return {
                  notebook: notebook,
                  notes: await notebookService.readNotesByNotebook(
                    Number(params.notebookId)
                  ),
                } as NotebookDetailsLoader;*/
                  }}
                  /*action={async ({ request }) => {
                console.log("loader action.");
              }}*/
                />
                <Route path="/" element={<GlobalSearchNotes />} />
                <Route path="/search" element={<GlobalSearchNotes />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Provider>
  );
}

export function sleep(n: number = 500) {
  return new Promise((r) => setTimeout(r, n));
}

export function Fallback() {
  return <p>Performing initial data load</p>;
}

export function RootPage() {
  return <Outlet />;
}

//v2
/*const router = createBrowserRouter(
    createRoutesFromElements(
      <>
      <Route path="/" element={<HomePage />}>            
              <Route path="note/detail" element={<NoteDetail />} />
              <Route path="note/new" element={<NoteNew />} />
              <Route path="notebook/details/:notebookId" 
                     element={<NotebookDetailsPage />} 
                     loader={async ({ params }) => {
                      console.log("loader router "+params.notebookId)
                      const notebook = await notebookService.readNotebookById(Number(params.notebookId))
                      //setcurrentNotebook(notebook);
                      return {
                        notebook: notebook,
                        notes: await notebookService.readNotesByNotebook(Number(params.notebookId))                    } as NotebookDetailsLoader
                    }}
                    action={async ({ request }) => {
                      console.log("loader action.")                    
                    }}
              />
              
            </Route>
            <Route path='/login' element={<DigitPad />} />
            </>
            
    )
  );
  return (<RouterProvider router={router} fallbackElement={<Fallback />} />)
  */

//v1
/*function App() {   

  return (
    <>
       <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />}>            
            <Route path="note/detail" element={<NoteDetail />} />
            <Route path="note/new" element={<NoteNew />} />
            <Route path="notebook/details/:notebookId" 
                   element={<NotebookDetailsPage />} 
                   loader={async ({ params }) => {
                    console.log("loader router.")
                    return await notebookService.readNotebookById(Number(params.notebookId));
                  }}
                  action={async ({ request }) => {
                    console.log("loader action.")                    
                  }}
            />
          </Route>
          {//<Route path="login" element={<LoginPage />} />//}                    
          {//<Route path="/" element={<LoginGPTPage />//}          
        </Routes>
      </BrowserRouter>
      
    </>
  )
}

export default App*/
